import { render, staticRenderFns } from "./EntityCompareDiff.vue?vue&type=template&id=1984723c&scoped=true&"
import script from "./EntityCompareDiff.vue?vue&type=script&lang=js&"
export * from "./EntityCompareDiff.vue?vue&type=script&lang=js&"
import style0 from "./EntityCompareDiff.vue?vue&type=style&index=0&id=1984723c&prod&scoped=true&lang=css&"
import style1 from "./EntityCompareDiff.vue?vue&type=style&index=1&id=1984723c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984723c",
  null
  
)

export default component.exports